import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

const DevicePasswordPropsSchema = z.object({
  devicePasswordValue: z.string(),
})

type DevicePasswordProps = z.infer<typeof DevicePasswordPropsSchema>

export class DevicePassword extends ValueObject<DevicePasswordProps> {
  public getValue(): string {
    return this.props.devicePasswordValue
  }

  /**
   * Creates a new DevicePassword instance.
   */
  public static create(devicePasswordValue: string): DevicePassword {
    const validatedProps = DevicePasswordPropsSchema.parse({
      devicePasswordValue,
    })
    return new DevicePassword(validatedProps)
  }
}
